import { render } from "./MessageLogs.vue?vue&type=template&id=d1e1a3f8&scoped=true"
import script from "./MessageLogs.vue?vue&type=script&lang=js"
export * from "./MessageLogs.vue?vue&type=script&lang=js"

import "./MessageLogs.vue?vue&type=style&index=0&id=d1e1a3f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e1a3f8"]])

export default __exports__